const indexData = [
  { letter: 'A', items: ['暗夜行者', '爱情呼叫转移', '阿凡达'] },
  { letter: 'B', items: ['变形金刚', '霸王别姬', '蝙蝠侠'] },
  { letter: 'C', items: ['超能陆战队', '楚门的世界', '刺客联盟'] },
  { letter: 'D', items: ['盗梦空间', '大鱼海棠', '碟中谍'] },
  { letter: 'E', items: ['E.T.外星人', '恶人传'] },
  { letter: 'F', items: ['疯狂动物城', '飞屋环游记'] },
  { letter: 'G', items: ['钢铁侠', '功夫', '孤注一掷'] },
  { letter: 'H', items: ['海王', '黑客帝国', '哈利波特'] },
  { letter: 'J', items: ['极限追凶', '寄生虫', '教父'] },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-list-check-2 text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            影片索引
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          悟空影视电影大全 - 按字母快速查找影片
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexData.map((group) => (
            <div
              key={group.letter}
              className="p-4 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-200 cursor-pointer group"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-8 h-8 rounded-md bg-primary-500/10 flex items-center justify-center text-sm font-bold text-primary-400 group-hover:bg-primary-500/20 transition-colors">
                  {group.letter}
                </span>
                <span className="text-[10px] text-foreground-600">{group.items.length} 部影片</span>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {group.items.map((item) => (
                  <span
                    key={item}
                    className="px-2 py-1 text-[11px] text-foreground-400 bg-background-50 rounded hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 text-center">
          <span className="inline-flex items-center gap-1 px-4 py-2 text-xs text-foreground-500 bg-background-100 rounded-full border border-background-200/60 cursor-pointer hover:border-primary-500/30 transition-all">
            <i className="ri-arrow-down-s-line"></i>
            展开更多字母索引（A - Z）
          </span>
        </div>
      </div>
    </section>
  );
}